// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"380":"bf4064b4","757":"27ee96b5"}[chunkId] + ".js";
};